<mat-slide-toggle
        *ngIf="canadaSysvarEnabled"
        [(ngModel)]="checked"
        color="accent"
        (change)="setIsKilometerState()"
        [disabled]="isDisabled"
        class="distance-toggle"
>Distance in Kilometers</mat-slide-toggle>
